export const ENTER_ORDER_DETAILS='ENTER_ORDER_DETAILS'
export const ENTER_BILLING_DETAILS='ENTER_BILLING_DETAILS'
export const OPTIONS='OPTIONS'
export const GET_SUPPLIER_ORDERS='GET_SUPPLIER_ORDERS'
export const START_LOADING_ORDERS='START_LOADING_ORDERS'
export const END_LOADING_ORDERS='END_LOADING_ORDERS'